import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useContext, useMemo } from "react";
import { CfgObjectDebug, CsAttributeDebug, } from "@plansoft-configuration-renderer/debug";
import { CsAttributeController, ShowInactiveAttributesContext, ShowNotVisibleAttributesContext, useCsAttributes, } from "@plansoft-configuration-renderer/framework";
import { AttributeSelectorByAttributeType } from "../Attributes/AttributeSelectorByAttributeType";
import { ConfigurationHeadline, ConfigurationTypeCode } from "../Configuration";
import { ConfigurationBackdrop } from "../Configuration/ConfigurationBackdrop";
/**
 * Display the attributes however you want
 *
 * ***Important:***
 * Use the `CsAttributeController` to enable use of the attribute context
 */
export function SimpleAttributeStrategy() {
    const attributes = useCsAttributes();
    const showInactiveAttributes = useContext(ShowInactiveAttributesContext);
    const showNotVisibleAttributes = useContext(ShowNotVisibleAttributesContext);
    const activeAttributes = useMemo(() => {
        return attributes
            .filter((attribute) => attribute.isActive || showInactiveAttributes)
            .filter((attribute) => attribute.isVisible || showNotVisibleAttributes);
    }, [attributes, showInactiveAttributes, showNotVisibleAttributes]);
    return (_jsxs(_Fragment, { children: [_jsx(CfgObjectDebug, {}), _jsx(ConfigurationBackdrop, {}), _jsx(ConfigurationHeadline, {}), _jsx(ConfigurationTypeCode, {}), activeAttributes.map((a) => (
            // Inject the attribute context
            _jsxs(CsAttributeController, { attribute: a, children: [_jsx(CsAttributeDebug, {}), _jsx(AttributeSelectorByAttributeType, {})] }, a.id)))] }));
}
//# sourceMappingURL=SimpleAttributeStrategy.js.map